import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container } from "pixi.js";
import HomeBtn from "./homeBtn";
import Objectif from "../levels/objectif";
const DECAL = 122;
export default class HomeMenu extends Container {
  constructor() {
    super();
    this._btns = [];
    this._firstTime = true;
    this._btnsContainer = new Container();
    this.addChild(this._btnsContainer);
    this._init();
  }
  _init() {
    this.skin = new HomeBtn(assets.textures.skin.texture, assets.local.skinsMenuTitle);
    this._btns.push(this.skin);
    this._btnsContainer.addChild(this.skin);
    this.skin.click = () => {
      config.skinPop.show();
      config.boosterRvPopin.hide();
    };

    //this.visible = false;
  }
  positionBtns() {
    let decalPlus = this._btnsContainer.children.length > 3 ? 0 : 40;
    let pos = this._btnsContainer.children.length >= 4 || this._btnsContainer.children.length == 1 ? 50 + DECAL : config.view.x / 2 - (DECAL + decalPlus) * (this._btnsContainer.children.length - 1) / 2;
    for (let i = 0; i < this._btnsContainer.children.length; i++) {
      this._btnsContainer.children[i].x = pos;
      pos += DECAL + decalPlus;
    }
  }
  setBtns(msg) {
    this.positionBtns();
    if (this._firstTime && !config.gameStarted) {
      this.visible = true;
      this._firstTime = false;
      for (let i = 0; i < this._btns.length; i++) {
        this._btns[i].scale.set(0);
        gsap.to(this._btns[i].scale, {
          delay: i * .07 + .5,
          duration: .3,
          x: this._btns[i].initScale,
          y: this._btns[i].initScale,
          ease: "back.out(2)"
        });
      }
      config.level.clearInterstitialDelay();
    }
  }
  removeAds() {
    this.positionBtns();
    this.show();
  }
  show() {
    this.visible = true;
    for (let i = 0; i < this._btns.length; i++) {
      this._btns[i].scale.set(0);
      gsap.to(this._btns[i].scale, {
        delay: .5,
        duration: .3,
        x: this._btns[i].initScale,
        y: this._btns[i].initScale,
        ease: "back.out(2)"
      });
    }
    config.level.clearInterstitialDelay();
  }
  hide() {
    for (let i = 0; i < this._btns.length; i++) {
      gsap.to(this._btns[i].scale, {
        duration: .3,
        x: 0,
        y: 0
      });
    }
    gsap.delayedCall(.3, () => {
      this.visible = false;
    });
    config.level.launchInterstitialInterval();
    this.checkForSkin();
  }
  checkForSkin() {
    this.skin.showAlert = config.skinPop.checkForAlert();
  }
  set enable(val) {
    if (val) {
      this.skin.tint = 0xffffff;
    } else {
      this.skin.tint = 0x777777;
    }
    this.skin.interactive = val;
  }
}
